module.exports = __webpack_public_path__ + "img/chatGPT.c81b9902.png";